import React from 'react';
import PropTypes from 'prop-types';
import deleteIcon from 'assets/img/deleteIcon.png';

import './style.scss';

const DeleteButton = ({
	onClick,
}) => (
  <button className="button-delete" onClick={onClick}>
    <img className="button-delete__img" src={deleteIcon} alt="" />
  </button>
);

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/components/ui/Buttons/DeleteButton/index.js